
import React from 'react';
import { Button } from '@/components/ui/button';
import { AlertCircle, Database } from 'lucide-react';

interface ConnectionErrorAlertProps {
  connectionError: string | null;
  dataSource: 'supabase' | 'mock';
}

export const ConnectionErrorAlert: React.FC<ConnectionErrorAlertProps> = ({ 
  connectionError, 
  dataSource 
}) => {
  // Если данные успешно загружаются из Supabase, не показываем уведомление
  if (dataSource === 'supabase' || !connectionError) return null;

  return (
    <div className="p-4 mb-4 bg-muted/30 border rounded-md">
      <div className="flex items-start">
        <AlertCircle className="h-5 w-5 text-muted-foreground mt-0.5 mr-2" />
        <div>
          <p className="font-medium text-sm">
            Используются тестовые данные
          </p>
          <p className="mt-1 text-sm text-muted-foreground">
            {connectionError}
          </p>
        </div>
      </div>
    </div>
  );
};
